var map = {
	"./404.svg": "2948",
	"./admin/business.svg": "2927",
	"./admin/campus.svg": "14cf",
	"./admin/class.svg": "3533",
	"./admin/parents.svg": "699c",
	"./admin/staff.svg": "6b65",
	"./admin/student.svg": "7888",
	"./admin/subject.svg": "34f9",
	"./admin/teacher.svg": "2572",
	"./auth/auth-banner.png": "e10e",
	"./documentation/imge1.png": "cd2b",
	"./documentation/imge10.png": "958f",
	"./documentation/imge11.png": "06f9",
	"./documentation/imge12.png": "7aea",
	"./documentation/imge13.png": "5729",
	"./documentation/imge14.png": "e742",
	"./documentation/imge15.png": "8c97",
	"./documentation/imge2.png": "5a90",
	"./documentation/imge3.png": "f105",
	"./documentation/imge4.png": "90e6",
	"./documentation/imge5.png": "a838",
	"./documentation/imge6.png": "d9da",
	"./documentation/imge7.png": "6f1d",
	"./documentation/imge8.png": "5dcc",
	"./documentation/imge9.png": "c87c",
	"./documentation/syllabus_imge1.png": "1026",
	"./documentation/syllabus_imge2.png": "8e2f",
	"./documentation/syllabus_imge3.png": "b5ea",
	"./dummy-profile.png": "a6b0",
	"./dummy-user.jpg": "24a7",
	"./logo-green.png": "2a0b",
	"./logo-green.svg": "66d5",
	"./logo-old.svg": "24e9",
	"./logo.svg": "e347",
	"./masks/red_mask.vue": "fa2e",
	"./upload.svg": "ad34"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";